import { Timestamp } from 'firebase/firestore';

// ============================================
// Workshop V2 - Nouveau modèle
// ============================================

export enum BookingMode {
  SOLO = 'SOLO',
  DUO = 'DUO',
  SOLO_DUO = 'SOLO_DUO',
}

export type WorkshopType = 'public' | 'health' | 'teambuilding';

export interface WorkshopV2 {
  id: string;
  title: string;
  description: string;
  type: WorkshopType;
  date: Timestamp;
  duration: number;
  location: string;
  bookingMode: BookingMode;
  priceSolo: number;
  priceDuo: number;
  maxParticipants: number;
  remainingPlaces: number;
  imageUrl: string;
  active: boolean;
  createdBy: string;
  createdAt: Timestamp;
}

// ============================================
// Workshop V1 - Ancien modèle (deprecated)
// ============================================

/** @deprecated Utiliser WorkshopV2 à la place */
export interface Workshop {
  id: string;
  title: string;
  description: string;
  type: 'public' | 'health' | 'teambuilding';
  subtype: 'beginner' | 'advanced' | 'duo' | null;
  date: Timestamp;
  duration: number;
  recurrence: 'one-time' | 'monthly' | 'weekly' | null;
  location: string;
  price: number;
  maxParticipants: number;
  remainingPlaces: number;
  imageUrl: string;
  active: boolean;
  createdBy: string;
  createdAt: Timestamp;
}
